import React from 'react';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from "@mui/material/Button";

const MessageList = messages => (
  <>
    {messages.map(msg => (
      <Typography key={msg} variant="body1" style={{margin: '0px 12px'}}>
        {msg}
      </Typography>
    ))}
  </>
);

const DialogErrorMessage = ({ message }) => {
  const content = Array.isArray(message) ? MessageList(message) : message || 'Houve um problema na solicitação.';

  const goBack = () => {
    window.history.go(-1);
  };

  return (
    <>
      <Dialog maxWidth="lg" open>
        <DialogTitle>
          Ops!
        </DialogTitle>
        <DialogContent style={{ padding: '8px 12px', minWidth: '400px' }}>
          <Box>{ content }</Box>
        </DialogContent>
        <DialogActions>
          <Box my={1} mx={1}>
            <Button
              color="primary"
              onClick={goBack}
            >
              Voltar
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DialogErrorMessage;